import PropTypes from "prop-types";

/** Keys mirrored from `CarrierProfileHeaderCards` `{ ... } = vm` destructure. */
export const CARRIER_PROFILE_HEADER_CARDS_VM_SHAPE = {
  setIsEditingCarrier: PropTypes.func.isRequired,
  handleSaveCarrier: PropTypes.func.isRequired,
  setCarrierDetails: PropTypes.func.isRequired,
  isEditingCarrier: PropTypes.bool.isRequired,
  isSavingCarrier: PropTypes.bool.isRequired,
  carrierDetails: PropTypes.object.isRequired,
  bondGraphData: PropTypes.shape({
    labels: PropTypes.array,
    datasets: PropTypes.array,
  }).isRequired,
  carrier: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

/** Keys mirrored from `CarrierProfileDialogs` `{ ... } = vm` destructure. */
export const CARRIER_PROFILE_DIALOGS_VM_SHAPE = {
  handleCloseUpdateCommissionDialog: PropTypes.func,
  openUpdateCommissionDialog: PropTypes.bool,
  setCommissionEffectiveDate: PropTypes.func,
  handleCloseEditBondDialog: PropTypes.func,
  setOpenEditLicenseDialog: PropTypes.func,
  setOpenEditCompanyDialog: PropTypes.func,
  setIsEditLimitDialogOpen: PropTypes.func,
  handleCloseCompanyDialog: PropTypes.func,
  handleUpdateLicenseInfo: PropTypes.func,
  setCommissionPercentage: PropTypes.func,
  setOpenAddLicenseDialog: PropTypes.func,
  commissionEffectiveDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  commissionDetailsLoading: PropTypes.bool,
  setOpenCommissionDialog: PropTypes.func,
  isSubmittingCommission: PropTypes.bool,
  handleCloseStateDialog: PropTypes.func,
  setLimitAuthorityLimit: PropTypes.func,
  handleCloseLimitDialog: PropTypes.func,
  handleUpdateCommission: PropTypes.func,
  setCommissionBondType: PropTypes.func,
  setTeamMemberPriority: PropTypes.func,
  handleCloseBondDialog: PropTypes.func,
  handleCloseEditDialog: PropTypes.func,
  openEditLicenseDialog: PropTypes.bool,
  setTeamMemberPosition: PropTypes.func,
  setLimitEffectiveDate: PropTypes.func,
  isEditLimitDialogOpen: PropTypes.bool,
  openEditCompanyDialog: PropTypes.bool,
  handleAddLicenseInfo: PropTypes.func,
  commissionPercentage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  setCommissionPercent: PropTypes.func,
  openAddLicenseDialog: PropTypes.bool,
  openCommissionDialog: PropTypes.bool,
  setEditLimitDetails: PropTypes.func,
  handleAddCommission: PropTypes.func,
  isSubmittingLicense: PropTypes.bool,
  setTeamMemberStatus: PropTypes.func,
  handleUpdateCompany: PropTypes.func,
  limitAuthorityLimit: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  teamMemberPriority: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  setNewLicenseValue: PropTypes.func,
  setTeamMemberPhone: PropTypes.func,
  openEditBondDialog: PropTypes.bool,
  teamMemberPosition: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  handleUpdateMember: PropTypes.func,
  commissionBondType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  setEditCompanyNAIC: PropTypes.func,
  setTeamMemberEmail: PropTypes.func,
  setUpdatedBondCode: PropTypes.func,
  limitEffectiveDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  setEditCompanyName: PropTypes.func,
  setNewLicenseType: PropTypes.func,
  commissionPercent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  handleCloseDialog: PropTypes.func,
  openCompanyDialog: PropTypes.bool,
  setTeamMemberName: PropTypes.func,
  setSelectedMember: PropTypes.func,
  handleUpdateLimit: PropTypes.func,
  teamMemberStatus: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  editLimitDetails: PropTypes.object,
  setEffectiveDate: PropTypes.func,
  handleAddCompany: PropTypes.func,
  handleUpdateBond: PropTypes.func,
  setLimitBondType: PropTypes.func,
  newLicenseValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  openStateDialog: PropTypes.bool,
  handleAddLimits: PropTypes.func,
  updatedBondCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  teamMemberPhone: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  editCompanyName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  openLimitDialog: PropTypes.bool,
  editCompanyNAIC: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  teamMemberEmail: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  teamMemberName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  handleAddState: PropTypes.func,
  openBondDialog: PropTypes.bool,
  setCompanyNAIC: PropTypes.func,
  selectedMember: PropTypes.object,
  commissionData: PropTypes.object,
  setCompanyName: PropTypes.func,
  newLicenseType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  openEditDialog: PropTypes.bool,
  setSendInvite: PropTypes.func,
  handleAddBond: PropTypes.func,
  limitBondType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  effectiveDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  handleInvite: PropTypes.func,
  setStateName: PropTypes.func,
  isSubmitting: PropTypes.bool,
  setBondCode: PropTypes.func,
  companyNAIC: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  setBondName: PropTypes.func,
  setBondType: PropTypes.func,
  companyName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  priorities: PropTypes.array,
  sendInvite: PropTypes.bool,
  statesList: PropTypes.array,
  bondsList: PropTypes.array,
  positions: PropTypes.array,
  stateName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  bondType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  bondName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  bondCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  statuses: PropTypes.array,
  open: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

/** Keys mirrored from `CarrierProfileTabsCard` `{ ... } = vm` destructure. */
export const CARRIER_PROFILE_TABS_CARD_VM_SHAPE = {
  handleChangeRowsPerPageCommissions: PropTypes.func,
  handleOpenUpdateCommissionDialog: PropTypes.func,
  handleChangeRowsPerPageCompanies: PropTypes.func,
  handleChangeRowsPerPageLimits: PropTypes.func,
  handleChangeRowsPerPageStates: PropTypes.func,
  handleChangeRowsPerPageBonds: PropTypes.func,
  handleChangeRowsPerPageTeam: PropTypes.func,
  handleChangePageCommissions: PropTypes.func,
  handleChangePageCompanies: PropTypes.func,
  handleOpenCompanyDialog: PropTypes.func,
  setOpenAddLicenseDialog: PropTypes.func,
  handleDeleteLicenseInfo: PropTypes.func,
  setOpenCommissionDialog: PropTypes.func,
  rowsPerPageCommissions: PropTypes.number,
  handleChangePageLimits: PropTypes.func,
  handleChangePageStates: PropTypes.func,
  handleDeleteCommission: PropTypes.func,
  handleEditCompanyClick: PropTypes.func,
  handleOpenStateDialog: PropTypes.func,
  handleOpenLimitDialog: PropTypes.func,
  handleChangePageBonds: PropTypes.func,
  handleOpenEditLicense: PropTypes.func,
  handleChangePageTeam: PropTypes.func,
  rowsPerPageCompanies: PropTypes.number,
  deleteCompanyLoading: PropTypes.bool,
  handleEditLimitClick: PropTypes.func,
  handleOpenBondDialog: PropTypes.func,
  handleDefaultChange: PropTypes.func,
  handleEditBondClick: PropTypes.func,
  handleDeleteCompany: PropTypes.func,
  editCompanyLoading: PropTypes.bool,
  handleDeleteMember: PropTypes.func,
  commissionLoading: PropTypes.bool,
  handleDeleteLimit: PropTypes.func,
  rowsPerPageLimits: PropTypes.number,
  rowsPerPageStates: PropTypes.number,
  handleDeleteState: PropTypes.func,
  rowsPerPageBonds: PropTypes.number,
  handleOpenDialog: PropTypes.func,
  companiesLoading: PropTypes.bool,
  handleDeleteBond: PropTypes.func,
  rowsPerPageTeam: PropTypes.number,
  pageCommissions: PropTypes.number,
  handleEditClick: PropTypes.func,
  licenseLoading: PropTypes.bool,
  pageCompanies: PropTypes.number,
  carrierLimits: PropTypes.array,
  paginationSx: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
    PropTypes.array,
  ]),
  bondsLoading: PropTypes.bool,
  licenseInfos: PropTypes.array,
  formatAmount: PropTypes.func,
  commissions: PropTypes.array,
  teamMembers: PropTypes.array,
  headerRowSx: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
    PropTypes.array,
  ]),
  setTabValue: PropTypes.func,
  tableCardSx: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
    PropTypes.array,
  ]),
  pageStates: PropTypes.number,
  pageLimits: PropTypes.number,
  formatDate: PropTypes.func,
  companies: PropTypes.array,
  pageBonds: PropTypes.number,
  pageTeam: PropTypes.number,
  tabValue: PropTypes.number,
  loading: PropTypes.bool,
  carrier: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  states: PropTypes.array,
  bonds: PropTypes.array,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
